import { useId } from "react";
import { Field, FieldLabel } from "@volca/ui/components/ui/field";
import { Input } from "@volca/ui/components/ui/input";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { Textarea } from "@volca/ui/components/ui/textarea";

const BusinessInfoPair = ({
  isEditMode,
  isTextArea,
  label,
  onChange,
  placeholder,
  value,
  className,
  name,
}: {
  isEditMode?: boolean;
  isTextArea?: boolean;
  label: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  placeholder?: string;
  value?: string | null;
  className?: string;
  name?: string;
}) => {
  const fieldId = useId();

  return (
    <Stack align="start" gap={4} className={className || "w-full sm:size-1/4"}>
      {!isEditMode ? (
        <Stack className="w-full" align="start" gap={2}>
          <Text variant="label" tone="muted">
            {label}
          </Text>
          {value ? <Text>{value}</Text> : <Text tone="muted">Not set</Text>}
        </Stack>
      ) : isTextArea ? (
        <Stack className="w-full" align="start" gap={2}>
          <Text id={fieldId} weight="semibold" variant="caption" tone="muted">
            {label}
          </Text>
          <Textarea
            aria-labelledby={fieldId}
            className="min-h-32"
            value={value || ""}
            onChange={onChange}
            placeholder={placeholder}
          />
        </Stack>
      ) : (
        <Field>
          <FieldLabel htmlFor={fieldId}>{label}</FieldLabel>
          <Input
            id={fieldId}
            value={value || ""}
            onChange={onChange}
            placeholder={placeholder}
            name={name}
          />
        </Field>
      )}
    </Stack>
  );
};

export default BusinessInfoPair;
